import { DoorStyleText, FinishText, UnavailableDataPlaceholderText } from "constants/text";
import { ReplacementCartItem } from "features/reducers/replacementOrder/cart.ts";
import {
	ReplacementReasonsHeaderContainerInfo,
	ReplacementReasonsHeaderContainerSku,
	ReplacementReasonsHeaderContainerSkuWrapper,
	ReplacementReasonsHeaderContainerWrapper
} from "components/Replacements/components/ReplacementReasonsHeaderContainer/ReplacementReasonsHeaderContainer.styles.ts";

interface ReplacementReasonsHeaderContainerProps {
	item: ReplacementCartItem;
}
const ReplacementReasonsHeaderContainer = ({ item }: ReplacementReasonsHeaderContainerProps) => {
	return (
		<ReplacementReasonsHeaderContainerWrapper>
			<ReplacementReasonsHeaderContainerSkuWrapper data-testid="replacementReasonHeader-sku-description">
				<span>{item.lineItemNumber}</span>
				<ReplacementReasonsHeaderContainerSku>
					<span data-testid="replacementReasonHeader-sku">{item.sku}</span>
					<span data-testid="replacementReasonHeader-description">{item.description}</span>
				</ReplacementReasonsHeaderContainerSku>
			</ReplacementReasonsHeaderContainerSkuWrapper>
			<ReplacementReasonsHeaderContainerInfo>
				<div>
					<span>{DoorStyleText}</span>
					<span data-testid="replacementReasonHeader-doorStyle">
						{item.doorStyle ?? UnavailableDataPlaceholderText}
					</span>
				</div>
				<div>
					<span>{FinishText}</span>
					<span data-testid="replacementReasonHeader-finish">
						{item.finish ?? UnavailableDataPlaceholderText}
					</span>
				</div>
			</ReplacementReasonsHeaderContainerInfo>
		</ReplacementReasonsHeaderContainerWrapper>
	);
};

export default ReplacementReasonsHeaderContainer;
